import { React, useState } from 'react';
import { Button } from 'react-bootstrap';
import { library } from '@fortawesome/fontawesome-svg-core';
import { fal } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Watchlist } from '../../services/Contexture/Watchlist';
import { toast } from 'react-toastify';

library.add(fal);

const WatchListButton = ({ profileId, docId, label }) => {
  const [watch, setWatch] = useState(false);
  const handleClick = async (e) => {
    try {
      const response = await Watchlist.addDocument(docId, {
        profileId: profileId,
      });

      if (response) {
        setWatch(true);
        if (typeof window !== 'undefined') {
          window.dispatchEvent(new Event('refreshDocLists'));
        }
        toast.success('Added to watchlist', {
          position: 'top-right',
          autoClose: 3000,
        });
      }
    } catch (err) {
      toast.error('Failed to add to watchlist', {
        position: 'top-right',
        autoClose: 3000,
      });
    }
  };

  return (
    <Button
      variant='text'
      onClick={() => handleClick()}
      className='add-watchlist'
      data-testid='add-to-watchlist-button'
    >
      <FontAwesomeIcon
        icon={watch ? ['fal', 'check'] : ['fal', 'thumbs-up']}
      ></FontAwesomeIcon>
      {label ? <span>{label}</span> : null}
    </Button>
  );
};
export default WatchListButton;
